import { useEffect } from 'react'

import { isOnServer } from '@/utils'

export const useOnFirstScroll = (onFirstScroll: () => void) => {
	useEffect(() => {
		if (isOnServer) {
			return
		}

		const isAlreadyScrolled = window.scrollY > 0

		if (isAlreadyScrolled) {
			onFirstScroll()
		}

		window.addEventListener('scroll', onFirstScroll, {
			passive: true,
			once: true,
		})

		return () => window.removeEventListener('scroll', onFirstScroll)
	}, [onFirstScroll])
}
